import * as React from 'react';
import { ActionButton } from '../ActionButton/ActionButton';

export const CommandButton = ActionButton;
